export const mutations = {
  STORE_OILSRECEIVING(state, oils) {
    state.oils = oils;
  },

  addOilsItems(state) {
    state.grn_item_orders.push({
      product_id: "",
      cartons_qty: "",
      cartons_litres: "",
      total_qty: "",
      remarks: ""
    });
  },

  STORE_OILSRECEIVING_UPDATE(state, id) {
    let Oil = state.oils.find(function(oil) {
      return oil.id === id;
    });
    state.systemOilreceiving = Oil;
  },
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/oils/mutations.js